import colorScheme, { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Light = 'light',
  LightOutlined = 'light-outlined',
  Danger = 'danger',
  Link = 'link',
  Ghost = 'ghost',
}

export enum ButtonSize {
  sm = 'sm',
  md = 'md',
}

const buttonTheme = {
  defaultProps: {
    variant: ButtonVariant.Primary,
  },
  baseStyle: {
    borderRadius: '6px',
  },
  sizes: {
    [ButtonSize.md]: {
      height: '50px',
      fontSize: FontSize.md,
      fontWeight: 600,
      pl: '20px',
      pr: '20px',
    },
    [ButtonSize.sm]: {
      height: '30px',
      fontSize: FontSize.md,
      fontWeight: 600,
      pl: '12px',
      pr: '12px',
    },
  },
  variants: {
    [ButtonVariant.Primary]: {
      backgroundColor: colorScheme[Color.Primary500],
      color: colorScheme[Color.OnPrimary],

      _hover: {
        backgroundColor: colorScheme[Color.Primary600],

        _disabled: {
          backgroundColor: colorScheme[Color.Disabled],
        },
      },

      _disabled: {
        backgroundColor: colorScheme[Color.Disabled],
      },
    },
    [ButtonVariant.Danger]: {
      backgroundColor: colorScheme[Color.Danger300],
      color: colorScheme[Color.OnError],

      _hover: {
        backgroundColor: colorScheme[Color.Danger500],

        _disabled: {
          backgroundColor: colorScheme[Color.Disabled],
        },
      },

      _disabled: {
        backgroundColor: colorScheme[Color.Disabled],
      },
    },
    [ButtonVariant.Light]: {
      backgroundColor: colorScheme[Color.Light],
      color: colorScheme[Color.OnLight],

      _hover: {
        backgroundColor: colorScheme[Color.Shade100],

        _disabled: {
          backgroundColor: colorScheme[Color.Disabled],
        },
      },

      _disabled: {
        backgroundColor: colorScheme[Color.Disabled],
      },
    },
    [ButtonVariant.LightOutlined]: {
      backgroundColor: 'transparent',
      color: colorScheme[Color.Light],
      borderColor: colorScheme[Color.Light],
      border: '2px solid',

      _hover: {
        backgroundColor: 'transparent',

        _disabled: {
          backgroundColor: 'transparent',
          borderColor: colorScheme[Color.Disabled],
        },
      },

      _disabled: {
        borderColor: colorScheme[Color.Disabled],
      },
    },
    [ButtonVariant.Secondary]: {
      backgroundColor: colorScheme[Color.SecondaryButton],
      color: colorScheme[Color.OnSecondaryButton],

      _hover: {
        backgroundColor: colorScheme[Color.Shade600],

        _disabled: {
          backgroundColor: colorScheme[Color.Disabled],
        },
      },

      _disabled: {
        backgroundColor: colorScheme[Color.Disabled],
      },
    },
    [ButtonVariant.Link]: {
      color: colorScheme[Color.Primary500],
      fontWeight: 400,
    },
  },
};

export default buttonTheme;
